import { classNames } from "@ember-decorators/component";
import discourseTag from "discourse/helpers/discourse-tag";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const TagChooserRow = dt7948.c(class TagChooserRow extends SelectKitRowComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    {{discourseTag this.rowValue count=this.item.count noHref=true}}\n  ", {
      strictMode: true,
      scope: () => ({
        discourseTag
      })
    }), this);
  }
}, [classNames("tag-chooser-row")]);
export default TagChooserRow;